import 'src/components/loading-screen/loading.css';

import { observer } from 'mobx-react-lite';
import { useStores } from 'src/models';

import { DialogAnimate } from '../animate';

/**
 * ## LoadingScreen 설명
 * - API 요청 중에 화면에 로딩 중임을 표시하는 컴포넌트
 * - React Suspense의 fallback으로 사용될 때는 props 없이 호출됨
 */
const LoadingScreen = observer(function LoadingScreen({
  suspense = false,
}: {
  suspense?: boolean;
}) {
  const rootStore = useStores();
  const { loadingStore } = rootStore;

  // suspense가 true이거나 loadingStore.loading이 true일 때 로딩 UI를 표시
  const shouldShowLoading = suspense || loadingStore.loading;

  if (!shouldShowLoading) {
    return null;
  }

  return (
    <DialogAnimate
      open={shouldShowLoading}
      PaperProps={{
        style: {
          boxShadow: 'none',
          backgroundColor: 'transparent',
          overflow: 'hidden',
          textAlign: 'center',
          maxWidth: '100%',
        },
      }}
      sx={{ maxWidth: '100%' }}
      BackdropProps={{
        style: { backgroundColor: 'rgba(0, 0, 0, 0.1)' },
      }}
    >
      <span className="loading" />
    </DialogAnimate>
  );
});

// Suspense에서 사용하기 위한 로딩 컴포넌트
export const SuspenseLoadingScreen = () => <LoadingScreen suspense={true} />;

export default LoadingScreen;
